// src/components/MapComponent.js
import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

// Configuration de l'icône par défaut de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

// Force le recalcul de la taille une fois le layout en place
const ResizeHandler = () => {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 0);
  }, [map]);

  return null;
};

const MapComponent = ({ clubs }) => {
  return (
    <MapContainer
      center={[44.8378, -0.5792]}
      zoom={10}
      style={{ height: "500px", width: "100%" }}
    >
      <ResizeHandler />

      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      {clubs.map((club, index) => {
        if (club.latitude && club.longitude) {
          return (
            <Marker key={index} position={[club.latitude, club.longitude]}>
              <Popup>
                <strong>{club.nom_club}</strong>
                <br />
                {club.adresse}
                <br />
                {club.commune}
              </Popup>
            </Marker>
          );
        }
        return null;
      })}
    </MapContainer>
  );
};

export default MapComponent;
